module.exports = __webpack_public_path__ + "static/media/MalgunGothic.39d1d05a.eot";